'use strict';exports.__esModule = true;var _values = require('lodash/values');var _values2 = _interopRequireDefault(_values);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isDeepEmpty = function isDeepEmpty(val) {
  if ((0, _isObject2.default)(val)) {
    return (0, _values2.default)(val).reduce(function (res, v) {return res && isDeepEmpty(v);}, true);
  }
  return val !== 0 && val !== false && !val;
};exports.default =

isDeepEmpty;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/is-deep-empty.js
// module id = 3140
// module chunks = 0